// External libraries
import React from 'react';

// Internal modules
import { features, getContent } from '@/lib';
import { PayLaterTextLink } from './PayLaterTextLink';
import { Legend } from './styles';

interface GetPayNowHeaderContentReturn {
  header: string;
  subheader: JSX.Element;
}

export const getPayNowHeaderContent = (
  isBankTab = false,
): GetPayNowHeaderContentReturn => {
  const isGuestFlow = features.someActive('isOptionalSignup', 'isPOMAEligible');
  const shouldShowBnplLink = features.get('bnplExperience') === 'LINK';
  const hasGuestXOSepaUpdate = features.isActive('hasGuestXOSepaUpdate');
  const isDebitRequired = features.isActive('isDebitRequiredTransaction');

  const keys = {
    flow: isGuestFlow ? 'guest' : 'signup',
    subFlow: 'base',
  };

  if (features.isActive('isDonation')) {
    keys.subFlow = 'donation';
  }

  let subHeader = getContent('valueProps.payWith.guest.base');

  if (features.isActive('isStreamlineOptionalExperience')) {
    keys.subFlow = 'streamline';
    subHeader = getContent('simplifiedSectionHeaders.streamline.subHeading');
  }

  if (isBankTab) {
    keys.subFlow += 'Bank';

    if (hasGuestXOSepaUpdate) {
      keys.flow = 'sepa';
    }
  }

  // check if content is present for debit only flow,
  // if not it will fallback to the default header and subheader for the flow
  if (
    isDebitRequired &&
    getContent('sectionHeaders.payWith.signup.debitOnly')
  ) {
    keys.flow = 'signup';
    keys.subFlow = 'debitOnly';
  }

  return {
    header: getContent(`sectionHeaders.payWith.${keys.flow}.${keys.subFlow}`),
    subheader: (
      <>
        {subHeader}
        {shouldShowBnplLink && <PayLaterTextLink />}
      </>
    ),
  };
};

export const showBillingDetailsTitle = (): JSX.Element | null => {
  const hasShippingAddressQualityExperiment = features.isActive(
    'hasShippingAddressQualityExperiment',
  );
  if (!hasShippingAddressQualityExperiment) {
    return null;
  }

  return <Legend>{getContent('fieldLabels.billingDetails')}</Legend>;
};
